import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  CREATE_CLIENT,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAILURE,
  CreateClientAction
} from 'src/redux/clientReducer'
import { FETCH_CLIENTS } from 'src/redux/clientsReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* CreateClientFlow(action: CreateClientAction): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = '/dealers_api/clients'
    const response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: POST,
      params: {
        client: action.payload
      }
    })
    yield put(CREATE_CLIENT_SUCCESS(response))
    yield put(FETCH_CLIENTS())
  } catch (error) {
    yield put(CREATE_CLIENT_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* CreateClientSaga(): Generator<any, void, any> {
  yield takeLatest(CREATE_CLIENT, CreateClientFlow)
}
